import { Link } from "react-router-dom";
import { ClipboardCheck, Users } from "lucide-react";
import { defineModuleUi, useOrg } from "@vixio/data";
import { formatInt, lazyPage } from "@vixio/ui";
import "./api";
import { useSurveyKpis } from "./widget-data";

export * from "./api";

// Telas carregadas sob demanda: cada uma vira um arquivo à parte no build.
const ProjectsPage = lazyPage(() => import("./ProjectsPage"), "ProjectsPage");
const ProjectPage = lazyPage(() => import("./ProjectPage"), "ProjectPage");
const InterviewersPage = lazyPage(() => import("./InterviewersPage"), "InterviewersPage");
const SharedResultsPage = lazyPage(() => import("./SharedResultsPage"), "SharedResultsPage");

function SurveysWidget() {
  const org = useOrg();
  const k = useSurveyKpis(org.id).data;
  return (
    <dl className="vx-dl">
      <dt>Projetos em campo</dt>
      <dd className="num">{formatInt(k?.fieldwork ?? 0)}</dd>
      <dt>Aguardando curadoria</dt>
      <dd className="num">{formatInt((k?.pending ?? 0) + (k?.flagged ?? 0))}</dd>
      <dt>Sinalizadas</dt>
      <dd className={(k?.flagged ?? 0) > 0 ? "num text-warn" : "num"}>{formatInt(k?.flagged ?? 0)}</dd>
      <dt>Candidaturas</dt>
      <dd className="num">{formatInt(k?.candidates ?? 0)}</dd>
      <dt />
      <dd>
        <Link to="/diagnostico/pesquisas">Abrir pesquisas</Link>
      </dd>
    </dl>
  );
}

export default defineModuleUi({
  key: "surveys",
  title: "Pesquisas de campo",
  domain: "diagnostics",
  icon: ClipboardCheck,
  menu: [
    { path: "/diagnostico/pesquisas", label: "Pesquisas de campo", minRole: "member", icon: ClipboardCheck, order: 50, keywords: "inpes amostra cotas quiosque curadoria exportação" },
    { path: "/diagnostico/entrevistadores", label: "Entrevistadores", minRole: "member", icon: Users, order: 51, keywords: "campo candidatura ENT atribuição" },
  ],
  routes: [
    { path: "/diagnostico/pesquisas", element: <ProjectsPage />, minRole: "member" },
    { path: "/diagnostico/pesquisas/:id", element: <ProjectPage />, minRole: "member" },
    { path: "/diagnostico/entrevistadores", element: <InterviewersPage />, minRole: "member" },
  ],
  publicRoutes: [{ path: "/resultados/:token", element: <SharedResultsPage /> }],
  widgets: [{ key: "surveys.field", title: "Pesquisas de campo", minRole: "member", span: 1, order: 33, element: SurveysWidget }],
});
